import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=535009ae"
import script from "./Google.vue?vue&type=script&setup=true&lang=js"
export * from "./Google.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports